import { HttpContext, HttpContextToken } from '@angular/common/http';

export const REQUIRE_CAPTCHA = new HttpContextToken<boolean>(() => false);

export function withCaptcha(context?: HttpContext): HttpContext {
  return (context ?? new HttpContext()).set(REQUIRE_CAPTCHA, true);
}
